import axios from 'axios';
import { config } from '../../../../config/envs';

const ADMIN_BASE_URL = config.app.adminBaseUrl;

export class ItemsAPI {
  static async list(params) {
    const response = await axios.get(`${ADMIN_BASE_URL}/items?${params.toString()}`);
    return response;
  }

  static async get(itemId) {
    const response = await axios.get(`${ADMIN_BASE_URL}/items/${itemId}`);
    return response.data;
  }

  static async create(values) {
    const response = await axios.post(`${ADMIN_BASE_URL}/items`, {
      name: values.name,
      code: values.code,
      value: values.value,
      saleType: values.saleType,
      statusType: values.statusType,
      benefits_type: values.benefitType,
      benefitType: values.benefitType,
      display_client: Boolean(values.display_client),
    });
    return response.data;
  }

  static async update(itemId, values) {
    const response = await axios.put(`${ADMIN_BASE_URL}/items/${itemId}`, {
      name: values.name,
      code: values.code,
      value: values.value,
      saleType: values.saleType,
      statusType: values.statusType,
      benefits_type: values.benefitType,
      benefitType: values.benefitType,
      display_client: Boolean(values.display_client),
    });
    return response.data;
  }
}
